import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { IArticleProductItem } from 'models/magazine/article/articleproductitem';
import { getProductCard } from 'redux/modules/product/productcard';
import { IProductCardDataAction } from 'models/product/productcard';
import { getShopCard } from 'redux/modules/shop/shopcard';
import { IShopCardAction } from 'models/shop/shopcard';
import { IStore } from 'redux/IStore';
import { IUserPreferences } from 'models/user/userpreferences';
import { Wishlists } from 'redux/modules/user/wishlists';
import { WishlistNodeType } from 'models/enums/nodetype/wishlistnodetype';
import { IAuthContext } from 'models/common';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';
import { goToCard } from 'helpers/common';
import { IItemCardList } from 'models/itemcard';
import { ItemCardList } from 'components';
const { connect } = require('react-redux');
require('./style.css');

interface IProps {
	items: IArticleProductItem[];
	userPreferences?: IUserPreferences;
	dispatch?: any;
	t?: (key: string) => string;
	location?: any;
	context?: IAuthContext;

	/* func props */
	getProductCard?: (id: string, target?: string) => IProductCardDataAction;
	getShopCard?: (id: string, target?: string) => IShopCardAction;
}

export const PreviousSlide = (props) => (
	<button className="buttonPrev" onClick={props.onClick} type="button">
		<img src={require('containers/Html/icons/arrow_prev_white.svg')} />
	</button>
);

export const NextSlide = (props) => (
	<button className="buttonNext" onClick={props.onClick} type="button">
		<img src={require('containers/Html/icons/arrow_next_white.svg')} />
	</button>
);

interface IArticleFeaturedProductsItemCardList extends IItemCardList {
	wishlistItem?: (itemType: string, itemId: string) => void;
	unwishItem?: (itemType: string, itemId: string) => void;
}

interface IState {
	isDragging: boolean;
	currentSlideIndex: number;
}

@connect(
	(state: IStore) => ({
		userPreferences: state.userPreferences,
	}),
	(dispatch) => ({
		dispatch,
		getProductCard: (id: string, target?: string) => dispatch(getProductCard(id, target)),
		getShopCard: (id: string, target?: string) => dispatch(getShopCard(id, target)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ArticleFeaturedItemsComponent extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			isDragging: false,
			currentSlideIndex: 0,
		};

		this.setCurrentSlideIndex = this.setCurrentSlideIndex.bind(this);
		this.setIsDragging = this.setIsDragging.bind(this);
		this.goToCard = this.goToCard.bind(this);
		this.wishlist = this.wishlist.bind(this);
		this.unwish = this.unwish.bind(this);
	}

	private setIsDragging(isDragging: boolean) {
		this.setState({ isDragging });
		this.forceUpdate();
	}

	private setCurrentSlideIndex(currentSlideIndex: number) {
		this.setState({ currentSlideIndex });
		this.forceUpdate();
	}

	private goToCard(id: string, type: string) {
		if (!this.state.isDragging) {
			goToCard(this.props.dispatch, id, type, '_blank');
		}
	}

	private wishlist(_, itemId: string) {
		const { isAuthenticated, signinRedirect } = this.props.context;
		if (isAuthenticated()) {
			const wishlists = new Wishlists(WishlistNodeType.ArticleFeaturedProducts);
			this.props.dispatch(wishlists.wishlist(itemId));
		} else {
			signinRedirect();
		}
	}

	private unwish(_, itemId: string) {
		const { isAuthenticated, signinRedirect } = this.props.context;
		if (isAuthenticated()) {
			const wishlists = new Wishlists(WishlistNodeType.ArticleFeaturedProducts);
			this.props.dispatch(wishlists.unwish(itemId));
		} else {
			signinRedirect();
		}
	}

	public render() {
		const { items, t } = this.props;
		const { currentSlideIndex } = this.state;

		const sliderSettings: any = {
			dots: false,
			infinite: false,
			swipeToSlide: true,
			speed: 500,
			slidesToScroll: 1,
			prevArrow: <PreviousSlide />,
			nextArrow: <NextSlide />,
			variableWidth: true,
			beforeChange: () => {
				this.setIsDragging(true);
			},
			afterChange: (currentSlideIndex: number) => {
				this.setIsDragging(false);
				this.setCurrentSlideIndex(currentSlideIndex);
			},
		};

		const sliderClassName: any = `${currentSlideIndex === 0 ? 'hideSliderPreviousButton' : ''} ${
			currentSlideIndex + 4 >= items.length ? 'hideSliderNextButton' : ''
		}`;

		const listProps: IArticleFeaturedProductsItemCardList = {
			items,
			itemType: c.NODE_TYPE_PRODUCT_ITEM_CARD,
			isCarousel: true,
			carouselSettings: sliderSettings,
			carouselClassName: sliderClassName,
			goToCard: this.goToCard,
			wishlistItem: this.wishlist,
			unwishItem: this.unwish,
			isInfiniteScroll: false,
			disableActions: true,
		};

		return (
			<div className="articleFeaturedItems">
				<div className="articleFeaturedItemsWrapper">
					<div className="row">
						<h2>{t('Magazine_Article_ArticleCard_FeaturedItems')}</h2>
					</div>
					<div className="row">
						<ItemCardList {...listProps} />
					</div>
				</div>
			</div>
		);
	}
}
const ArticleFeaturedItems = withAuthContext(ArticleFeaturedItemsComponent);
export { ArticleFeaturedItems };
